module.exports = __webpack_public_path__ + "img/bandcamp-icon.da569da1.png";